import React from 'react';
import { SlAINavigation } from '../../../features/navigation/public/SlAINavigation/SlAINavigation';

export const AINavigation = () => {
  return <SlAINavigation />;
};